import { render, staticRenderFns } from "./GeofenceTab.vue?vue&type=template&id=2868c36d"
import script from "./GeofenceTab.vue?vue&type=script&lang=js"
export * from "./GeofenceTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports